<template>
  <div class="regulations-container">
    <div class="regulations-content">
      <h1>iTender մրցույթների կանոնակարգ</h1>
      
      <h2>Կանոնակարգում կիրառվող հիմնական հասկացությունները</h2>
      
      <p><strong>Կազմակերպիչ (Գնորդ / Պատվիրատու)</strong><br>
      այն անձը կամ կազմակերպությունը, որը iTender համակարգում ստեղծում և վարում է մրցույթ կամ հարցում։</p>
      
      <p><strong>Մրցույթ (iTender մրցույթ)</strong><br>
      մրցակցային գնում, որի շրջանակում մասնակիցները ներկայացնում են առաջարկներ, և կազմակերպիչը մրցույթի պայմանների հիման վրա պարտավոր է ընտրել հաղթող(ներ)։</p>
      
      <p><strong>Հարցում (iTender հարցում)</strong><br>
      շուկայական առաջարկների կամ գների հավաքագրման գործընթաց, որի դեպքում կազմակերպիչը պարտավոր չէ հաղթող ընտրել կամ գնում կատարել։<br>
      Գործարք իրականացնելու դեպքում կիրառվում են սույն կանոնակարգի և/կամ կողմերի միջև կնքված պայմանագրի պայմանները։</p>
      
      <p><strong>Մրցույթի պայմաններ</strong><br>
      մրցույթի բոլոր պահանջների և կանոնների ամբողջություն (գնման առարկա, պայմաններ, ժամկետներ, գնահատման եղանակ և այլն)։</p>
      
      <p><strong>Մասնակից</strong><br>
      մրցույթին կամ հարցմանը մասնակցող իրավաբանական կամ ֆիզիկական անձ։</p>
      
      <p><strong>Գնման առարկա</strong><br>
      այն ապրանքը, աշխատանքը կամ ծառայությունը, որը կազմակերպիչը նախատեսում է ձեռք բերել։</p>
      
      <p><strong>Գնման առարկայի բնութագիր</strong><br>
      գնման առարկայի տեխնիկական և որակական պահանջները, ինչպես նաև մատակարարման/կատարման և վճարման պայմանները։</p>
      
      <p><strong>Առաջարկ</strong><br>
      մասնակցի կողմից ներկայացված գնային և/կամ ոչ գնային առաջարկը՝ իր կցված նյութերով։</p>
      
      <p><strong>Համակարգ</strong><br>
      iTender էլեկտրոնային հարթակը (www.itender.am)։</p>
      
      <p><strong>Օպերատոր</strong><br>
      «Այ Տենդեր» ՍՊԸ-ն, որը ապահովում է համակարգի տեխնիկական գործարկումը և սպասարկումը։<br>
      Օպերատորը մրցույթի կամ գործարքի կողմ չէ։</p>

      <p><strong>Բաց աճուրդ</strong><br>
      iTender մրցույթներում հաղթողին որոշելու եղանակ, որի դեպքում բավարար գնահատված մասնակիցները գնահատման փուլից հետո հնարավորություն են ստանում համակարգի միջոցով բարելավել իրենց ներկայացրած գնային առաջարկները։<br>
      Բաց աճուրդը կիրառվում է միայն այն դեպքում, երբ տվյալ մրցույթի պայմաններով կամ համակարգի կարգավորումներով նախատեսված է հաղթողի որոշման աճուրդային եղանակ։</p>

      <p><strong>Աճուրդի մասնակից</strong><br>
      Բաց աճուրդին մասնակցելու իրավունք ունեցող մասնակից, որի ներկայացրած առաջարկը գնահատման արդյունքում ճանաչվել է բավարար։</p>

      <p><strong>Ընթացիկ նվազագույն գին</strong><br>
      Բաց աճուրդի ընթացքում տվյալ պահին գործող ամենացածր համեմատվող գինը, որը հաշվարկվում է համակարգի կողմից՝ սույն կանոնակարգով սահմանված համեմատության կանոնների հիման վրա։</p>

      <p><strong>Նվազագույն քայլ</strong><br>
      Գնի նվազեցման նվազագույն չափը, որով մասնակիցը կարող է բարելավել առաջարկը բաց աճուրդի ընթացքում։ Նվազագույն քայլը սահմանվում է տոկոսային արտահայտությամբ և հաշվարկվում է ընթացիկ նվազագույն գնից։</p>

      <h3>1. Մրցույթի կազմակերպումը</h3>
      
      <p>1.1. iTender համակարգից օգտվելու համար կազմակերպիչները և մասնակիցները նախապես գրանցվում են համակարգում։</p>
      
      <p>1.2. Կազմակերպիչը մրցույթ կամ հարցում է ստեղծում համակարգում՝ լրացնելով պարտադիր դաշտերը և սահմանելով մրցույթի պայմանները։</p>
      
      <p>1.3. Արգելվում է մրցույթի կամ հարցման շրջանակում հրապարակել քաղաքական, գովազդային, վիրավորական կամ օրենքին հակասող բովանդակություն։</p>
      
      <p>1.4. Օպերատորը իրավասու է խախտումների դեպքում հեռացնել տվյալ հրապարակումը կամ սահմանափակել օգտատիրոջ հասանելիությունը համակարգին։</p>
      
      <h3>2. Գնման առարկայի բնութագիրը</h3>
      
      <p>2.1. Կազմակերպիչը պետք է գնման առարկան նկարագրի հնարավորինս հստակ՝ մասնակիցների համար հավասար և կանխատեսելի պայմաններ ապահովելու նպատակով։</p>
      
      <p>2.2. Բնութագրերը կարող են ներառել՝</p>
      <ul>
        <li>տեխնիկական տվյալներ,</li>
        <li>չափեր,</li>
        <li>որակի պահանջներ,</li>
        <li>մատակարարման պայմաններ և ժամանակացույցեր,</li>
        <li>նկարներ կամ այլ նյութեր,</li>
      </ul>
      <p>իսկ ծառայությունների և աշխատանքների դեպքում՝ նաև ծավալներ և կատարման հասցե։</p>
      
      <p>2.3. Եթե կազմակերպիչը չի կարող նախապես հստակ նշել գնման առարկայի ճշգրիտ քանակը, կարող է սահմանել առավելագույն քանակը։</p>
      
      <p>2.4. Այդ դեպքում կազմակերպիչը պարտավորվում է մրցույթի արդյունքում ձեռք բերել սահմանված առավելագույն քանակի ոչ պակաս, քան 80 տոկոսը։</p>
      
      <p>2.5. Գնման առարկայի բնութագրերում կարող է նշվել կոնկրետ ապրանքանիշ, մոդել, արտադրող, ծագման երկիր կամ աղբյուր։<br>
      Այդ դեպքում կազմակերպիչը կարող է կիրառել «կամ համարժեք» ձևակերպումը։<br>
      Պետք է հաշվի առնել, որ այդ ձևակերպման չկիրառումը կարող է ազդել մրցակցության մակարդակի և մրցույթի արդյունավետության վրա։</p>
      
      <h3>3. Մասնակցության իրավունք</h3>
      
      <p>3.1. Բաց մրցույթներին կարող են մասնակցել iTender համակարգում գրանցված բոլոր օգտատերերը։</p>
      
      <p>3.2. Սահմանափակ (հրավերով) մրցույթի դեպքում կարող են մասնակցել միայն կազմակերպչի կողմից հրավիրված անձինք։</p>
      
      <p>3.3. Արգելափակված հաշիվ ունեցող օգտատերերը չեն կարող մասնակցել մրցույթներին կամ կազմակերպել դրանք։</p>
      
      <p>3.4. Որակավորման կամ փորձառության պահանջները պարտադիր նախապես նշվում են մրցույթի պայմաններում։</p>
      
      <h3>4. Մրցույթի պայմանների պարզաբանումը և փոփոխությունը</h3>
      
      <p>4.1. Մրցույթի պայմանների վերաբերյալ հարցերը ներկայացվում են միայն մրցույթի պայմաններում նշված էլեկտրոնային փոստի հասցեին։</p>
      
      <p>4.2. Հարցերը կարող են ներկայացվել առաջարկների ներկայացման վերջնաժամկետից առնվազն 8 ժամ առաջ։</p>
      
      <p>4.3. Կազմակերպիչը պարտավոր է հարցմանը արձագանքել մինչև 2 ժամվա ընթացքում։</p>
      
      <p>4.4. Մրցույթի պայմանների փոփոխությունները հրապարակվում են համակարգում և հասանելի են դառնում բոլոր հնարավոր մասնակիցներին։</p>
      
      <p>4.5. Փոփոխության դեպքում առաջարկների ներկայացման վերջնաժամկետը վերահաշվարկվում է փոփոխության հրապարակման պահից։</p>
      
      <h3>5. Առաջարկների ներկայացումը</h3>
      
      <p>5.1. Մրցույթի պայմանները հրապարակվում են iTender համակարգում և հասանելի են դառնում համապատասխան գործունեություն ունեցող մասնակիցներին։<br>
      Կազմակերպիչը կարող է լրացուցիչ տարածել մրցույթի հղումը այլ միջոցներով։</p>
      
      <p>5.2. Մասնակիցը առաջարկը ներկայացնում է համակարգում։</p>
      
      <p>5.3. Առաջարկների ներկայացման վերջնաժամկետը լրանալուց առաջ առաջարկը կարող է փոփոխվել կամ չեղարկվել։</p>
      
      <p>5.4. Վերջնաժամկետից հետո առաջարկները համարվում են վերջնական։</p>
      
      <p>5.5. Առաջարկների գնահատման ընթացքում կազմակերպիչը իրավունք ունի պահանջել լրացուցիչ տեղեկություն կամ ապրանքի նմուշ՝ առաջարկի համապատասխանությունը ճշգրտելու նպատակով։</p>
      
      <p>5.6. Անհամապատասխանության դեպքում առաջարկը գնահատվում է անբավարար, և կիրառվում են սույն կանոնակարգի 6-րդ կետով նախատեսված դրույթները։</p>
      
      <h3>6. Օգտատերերի արգելափակումը</h3>
      
      <p>6.1. Կազմակերպիչը կամ Մասնակիցը կարող է արգելափակվել iTender համակարգից՝<br>
      սույն կանոնակարգի կամ մրցույթի պայմանների խախտման դեպքում,<br>
      որի մասին օգտատերը ծանուցվում է էլեկտրոնային փոստի միջոցով։</p>
      
      <p>6.2. Խախտումների դեպքում կիրառվում են հետևյալ պատասխանատվության միջոցները՝ կախված խախտման բնույթից և կրկնվելու հանգամանքից․</p>
      
      <p><strong>Առաջին խախտում</strong> – օգտատերը ստանում է զգուշացում</p>
      
      <p><strong>Երկրորդ խախտում</strong> – օգտատիրոջ հաշիվը արգելափակվում է 6 ամիս ժամկետով</p>
      
      <p><strong>Երրորդ խախտում</strong> – օգտատիրոջ հաշիվը արգելափակվում է ընդմիշտ</p>
      
      <p>6.3. Օգտատիրոջ արգելափակումը չի ազատում նրան մինչև այդ պահը ստանձնած պայմանագրային կամ մրցութային պարտավորություններից։</p>

      <p>6.4. Բաց աճուրդի ընթացքում ակնհայտ անիրական կամ կատարման ենթակա չհամարվող գնի ներկայացումը, ինչպես նաև այդ գնով պայմանագիր կնքելուց կամ պարտավորությունը կատարելուց հետագա հրաժարումը կարող է դիտարկվել որպես սույն կանոնակարգի խախտում։<br>
      Նման դեպքերում Օպերատորը կարող է կիրառել սույն կանոնակարգի 6-րդ բաժնով նախատեսված պատասխանատվության միջոցները, այդ թվում՝ զգուշացում, ժամանակավոր արգելափակում կամ մշտական արգելափակում։</p>

      <h3>7. Առաջարկի գնահատումը և հաղթողի որոշումը</h3>
      
      <p>7.1. Մրցույթներն իրականացվում են փակ գների սկզբունքով։</p>
      
      <p>7.2. Գնահատումն իրականացվում է նվազագույն գնի կամ լավագույն առաջարկի սկզբունքով՝ ըստ մրցույթի պայմանների։</p>
      
      <p>7.3. Լավագույն առաջարկի սկզբունքը կիրառելու դեպքում այդ տարբերակը պարտադիր նախապես սահմանվում է մրցույթի պայմաններում։<br>
      Հաղթողը որոշվում է ոչ միայն առաջարկված գնով, այլ նաև մրցույթի պայմաններում սահմանված ոչ գնային չափանիշների համակցված գնահատման արդյունքում։</p>
      
      <p>7.4. Գնային առաջարկների համեմատումն իրականացվում է՝ առանց ԱԱՀ-ի կամ հատուցման գումարով՝ կախված նրանից, թե կազմակերպիչը ինչ հարկատեսակով է աշխատում։</p>
      
      <p>7.5. Կազմակերպիչը պարտավոր է առաջարկների գնահատման արդյունքները ամփոփել և համակարգում հրապարակել մինչև 5 աշխատանքային օրվա ընթացքում։</p>
      
      <p>7.6. Հաղթողի հետ պայմանագիր չկնքելու դեպքում կազմակերպչի նկատմամբ կարող են կիրառվել 6-րդ կետով նախատեսված դրույթները։</p>

      <p>7.7. <strong>Բաց աճուրդի կիրառումը</strong></p>

      <p>Մրցույթի հաղթողը կարող է որոշվել բաց աճուրդի միջոցով, եթե տվյալ մրցույթի համար համակարգում ընտրված կամ սահմանված է աճուրդային հաղթողի որոշման եղանակը։<br>
      Բաց աճուրդը փակ գներով ներկայացված առաջարկների գնահատման շարունակությունն է և անցկացվում է միայն գնահատման փուլից հետո։</p>

      <p>7.8. <strong>Բաց աճուրդին մասնակցելու իրավունք</strong></p>

      <p>Բաց աճուրդին կարող են մասնակցել միայն այն մասնակիցները, որոնց առաջարկները գնահատման արդյունքում ճանաչվել են բավարար։<br>
      Անբավարար գնահատված մասնակիցները բաց աճուրդին մասնակցելու իրավունք չունեն։<br>
      Եթե բավարար գնահատված է միայն մեկ մասնակից, կազմակերպիչը կարող է առանց աճուրդ անցկացնելու տվյալ մասնակցին հայտարարել հաղթող՝ մրցույթի պայմանների և սույն կանոնակարգի դրույթների պահպանմամբ։</p>

      <p>7.9. <strong>Աճուրդի մեկնարկային գինը</strong></p>

      <p>Բաց աճուրդի մեկնարկային գին է համարվում բավարար գնահատված մասնակիցների ներկայացրած գներից նվազագույնը՝ համեմատության կանոնների կիրառմամբ։<br>
      Բաց աճուրդի ընթացքում ներկայացվող յուրաքանչյուր հաջորդ առաջարկ պետք է լինի ընթացիկ նվազագույն գնից առնվազն սահմանված նվազագույն քայլով ցածր։</p>

      <p>7.10. <strong>Աճուրդի ընթացքում ցուցադրվող տեղեկատվությունը</strong></p>

      <p>Բաց աճուրդի ընթացքում մասնակիցներին ցուցադրվում է միայն ընթացիկ նվազագույն գինը, իրենց սեփական առաջարկը, նվազագույն քայլը, մինչև աճուրդի ավարտը մնացած ժամանակը և տվյալ չափաբաժնի վերաբերյալ անհրաժեշտ հիմնական տեղեկատվությունը։</p>

      <p>Բաց աճուրդի ընթացքում չեն ցուցադրվում՝</p>
      <ul>
        <li>մասնակիցների անվանումները,</li>
        <li>մասնակիցների քանակը,</li>
        <li>մասնակիցների դիրքերը,</li>
        <li>այլ մասնակիցների ներկայացրած գները,</li>
        <li>ընթացիկ նվազագույն գինը ներկայացրած մասնակցի տվյալները։</li>
      </ul>

      <p>7.11. <strong>Գների ներկայացման և համեմատության կանոնները</strong></p>

      <p>Բաց աճուրդի ընթացքում մասնակիցը ներկայացնում է նոր գնային առաջարկ համակարգի միջոցով։<br>
      Աճուրդի ընթացքում մասնակցի ԱԱՀ կարգավիճակը չի փոփոխվում։ Համակարգը ավտոմատ կիրառում է հայտի ներկայացման փուլում մասնակցի կողմից նշված ԱԱՀ կարգավիճակը։<br>
      Աճուրդի ընթացքում ներկայացված բոլոր նոր գները համեմատության նպատակով վերահաշվարկվում են նույն տրամաբանությամբ, որը կիրառվել է գնահատման փուլում։<br>
      Գնային առաջարկների համեմատումն իրականացվում է առանց ԱԱՀ-ի կամ հատուցման գումարով՝ կախված նրանից, թե կազմակերպիչը ինչ հարկատեսակով է աշխատում։</p>

      <p>7.12. <strong>Չմասնակցելու դեպքը</strong></p>

      <p>Եթե բավարար գնահատված մասնակիցը բաց աճուրդի ընթացքում նոր գին չի ներկայացնում, նրա գնահատման փուլում ներկայացրած վերջնական գինը մնում է ուժի մեջ և մասնակցում է վերջնական համեմատությանը։</p>

      <p>7.13. <strong>Միաժամանակ ներկայացված առաջարկներ</strong></p>

      <p>Եթե բաց աճուրդի ընթացքում միաժամանակ ներկայացվում են մի քանի գնային առաջարկներ, դրանց հերթականությունը որոշվում է համակարգում ֆիքսված ժամանակային դրոշմի հիման վրա։<br>
      Հավասար նվազագույն գների դեպքում նախապատվությունը տրվում է այն մասնակցին, որի տվյալ գինը համակարգում ֆիքսվել է ավելի վաղ։</p>

      <p>7.14. <strong>Նախահաշվային արժեքից էականորեն ցածր առաջարկ</strong></p>

      <p>Եթե մասնակցի ներկայացրած առաջարկը նախահաշվային արժեքից ցածր է ավելի քան 25 տոկոսով, համակարգը կարող է ցուցադրել զգուշացում՝ մասնակցին առաջարկելով կրկին ստուգել ներկայացվող գնի հաշվարկը։<br>
      Նշված զգուշացումը տեղեկատվական բնույթ ունի և ինքնին չի արգելափակում առաջարկի ներկայացումը։</p>

      <p>7.15. <strong>Աճուրդի ավարտը և արդյունքների ամփոփումը</strong></p>

      <p>Բաց աճուրդն ավարտվում է համակարգում սահմանված ժամկետի լրանալուց հետո։<br>
      Աճուրդի ավարտից հետո սկսվում է արդյունքների ամփոփման գործընթացը, որը հաստատվում է կազմակերպչի կողմից։<br>
      Հաղթող է ճանաչվում այն մասնակիցը, որի վերջնական առաջարկը համեմատության կանոններով ամենացածրն է, եթե կազմակերպչի գնահատմամբ այդ գինը համարվում է ողջամիտ և կատարման ենթակա։</p>

      <p>7.16. <strong>Անիրական կամ ակնհայտ ցածր գնի ներկայացման հետևանքները</strong></p>

      <p>Բաց աճուրդի ընթացքում ներկայացված գինը համարվում է մասնակցի կողմից հաստատված առաջարկ։<br>
      Եթե մասնակիցը միտումնավոր ներկայացնում է ակնհայտ անիրական կամ չափազանց ցածր գին, իսկ հետո հրաժարվում է այդ գնով պայմանագիր կնքելուց կամ պարտավորությունը կատարելուց, այդ վարքագիծը կարող է դիտարկվել որպես անբարեխիղճ մասնակցություն։<br>
      Այդպիսի դեպքերում համակարգի Օպերատորը կարող է սահմանափակել կամ արգելափակել տվյալ կազմակերպության մասնակցությունը iTender մրցույթներին՝ սույն կանոնակարգի 6-րդ բաժնի դրույթներին համապատասխան։</p>

      <p>7.17. <strong>Աճուրդի չամփոփման դեպքը</strong></p>

      <p>Եթե բաց աճուրդի ավարտից հետո կազմակերպիչը սահմանված ժամկետում չի ամփոփում արդյունքները և չի հաստատում հաղթողին, համակարգում աճուրդը կարող է ստանալ «Պահանջվում է ամփոփում» կարգավիճակ։<br>
      Եթե կազմակերպիչը գնահատման ավարտից հետո չի կազմակերպում աճուրդ և չի հայտարարում հաղթող, ապա 2 օր անց մրցույթը կարող է ավտոմատ ստանալ «Ավարտված առանց հաղթողի որոշման» կարգավիճակ։<br>
      «Ավարտված առանց հաղթողի որոշման» կարգավիճակի դեպքում հաղթող չի ճանաչվում, պայմանագիր չի ձևավորվում, իսկ մրցույթի տվյալները պահպանվում են համակարգում։</p>

      <h3>8. Պայմանագրի կնքումը</h3>
      
      <p>8.1. Կազմակերպիչը մրցույթի արդյունքների ամփոփումից հետո մինչև 2 աշխատանքային օրվա ընթացքում համակարգի միջոցով հաղթող մասնակցին ուղարկում է պայմանագիր կնքելու առաջարկ։</p>
      
      <p>8.2. Հաղթող մասնակիցը պարտավոր է առաջարկը ստանալուց հետո մինչև 2 աշխատանքային օրվա ընթացքում ընդունել կամ մերժել այն։</p>
      
      <p>8.3. Չարձագանքման կամ մերժման դեպքում կազմակերպիչը մինչև հաջորդ 2 աշխատանքային օրվա ընթացքում համակարգի միջոցով առաջարկ է ներկայացնում հաջորդ տեղը զբաղեցրած մասնակցին։</p>
      
      <p>8.4. Պայմանագիրը կարող է կնքվել թղթային կամ էլեկտրոնային եղանակով։</p>
      
      <p>8.5. Պայմանագրի կատարման համար պատասխանատվությունը կրում են պայմանագրի կողմերը։</p>
      
      <h3>9. Մրցույթը չկայացած հայտարարելը և չեղարկելը</h3>
      
      <p>9.1. Մրցույթը համարվում է չկայացած, եթե՝<br>
      ա) ոչ մի առաջարկ չի ներկայացվել,<br>
      բ) առաջարկներից ոչ մեկը չի համապատասխանում մրցույթի պայմաններին,<br>
      գ) հարցման դեպքում կազմակերպիչը որոշում է չկնքել պայմանագիր։</p>
      
      <p>9.2. Մրցույթը կարող է չեղարկվել, եթե դադարում է գնման պահանջը կամ առաջանում է մրցույթի պայմանների էական փոփոխման անհրաժեշտություն։</p>
      
      <p>9.3. Չեղարկումը կատարվում է մինչև առաջարկների ներկայացման վերջնաժամկետը։</p>
      
      <h3>10. Որոշումների բողոքարկումը և վեճերի կարգավորումը</h3>
      
      <p>10.1. Մրցույթի մասնակիցը կամ կազմակերպիչը կարող է իր իրավունքների պաշտպանությունն իրականացնել օրենքով սահմանված կարգով։</p>
      
      <p>10.2. Մրցույթների հետ կապված հարաբերությունները կարգավորվում են Հայաստանի Հանրապետության քաղաքացիաիրավական օրենսդրությամբ և սույն կանոնակարգով։</p>
      
      <p>10.3. Օպերատորը վեճերի լուծման կողմ չէ, սակայն կարող է տրամադրել համակարգում առկա տվյալները իրավասու մարմինների պահանջով։</p>
      
      <h3>11. Պայմանագրի կատարման և հանձնման-ընդունման ֆիքսումը համակարգում</h3>
      
      <p>11.1. Մրցույթի արդյունքում կնքված պայմանագրերի շրջանակում ապրանքների մատակարարումը, ծառայությունների մատուցումը կամ աշխատանքների կատարումը համարվում են ավարտված միայն այն դեպքում, երբ դրանց արդյունքը հաստատվում է iTender համակարգի միջոցով։</p>
      
      <p>11.2. Կողմերը համակարգում նշում են հանձնման–ընդունման փաստը, կատարված ծավալը և ժամկետների պահպանումը կամ խախտումը։</p>
      
      <p>11.3. Համակարգը կարող է ապահովել պատվերների կառավարում, կատարման ժամկետների վերահսկում, հիշեցումներ և ծանուցումներ։</p>
      
      <p>11.4. Սույն բաժնի դրույթները չեն փոխարինում կողմերի միջև կնքված պայմանագրով սահմանված իրավունքներին և պարտականություններին, այլ ապահովում են դրանց կատարման փաստացի ֆիքսումը համակարգում։</p>
      
      <h3>12. Եզրափակիչ դրույթներ</h3>
      
      <p>12.1. iTender համակարգի միջոցով ուղարկված բոլոր ծանուցումները համարվում են պատշաճ կերպով ստացված դրանց օգտատիրոջ անձնական հաշվում հասանելի դառնալու պահից։</p>
      
      <p>12.2. Սույն կանոնակարգով սահմանված ժամկետների պահպանումը կարող է ժամանակավորապես կասեցվել անհաղթահարելի ուժի (force majeure) ազդեցության դեպքում, եթե այդ հանգամանքները ծագել են տվյալ մրցույթի կամ գործընթացի ընթացքում և կողմերը չեն կարողացել դրանք կանխատեսել կամ կանխարգելել։</p>
      
      <p>12.3. Անհաղթահարելի ուժի հանգամանքներ են համարվում՝ երկրաշարժը, ջրհեղեղը, հրդեհը, պատերազմը, ռազմական կամ արտակարգ դրության հայտարարումը, քաղաքական հուզումները, գործադուլները, հաղորդակցության կամ տեղեկատվական համակարգերի աշխատանքի լայնածավալ խափանումները, պետական մարմինների ակտերը կամ այլ իրադարձություններ, որոնք օբյեկտիվորեն անհնարին են դարձնում համակարգի միջոցով գործողությունների կատարումը։</p>
      
      <p>12.4. Անհաղթահարելի ուժի հանգամանքների դեպքում ժամկետների հաշվարկը կասեցվում է մինչև այդ հանգամանքների վերացումը կամ համակարգի բնականոն աշխատանքի վերականգնումը, որի մասին օգտատերերը ծանուցվում են iTender համակարգի միջոցով։</p>
      
      <p>12.5. Գրանցվելով iTender համակարգում, կազմակերպելով iTender մրցույթներ կամ մասնակցելով այդ մրցույթներին՝ օգտատերը հաստատում է, որ ծանոթացել է սույն կանոնակարգին, լիովին հասկացել է դրա բովանդակությունը և ընդունում է այն՝ առանց վերապահումների։</p>
      
      <h3>13. Տվյալների հասանելությունը, գաղտնիությունը և օգտագործումը</h3>
      
      <p>13.1. Մրցույթի կամ հարցման շրջանակում մասնակիցների կողմից ներկայացված բոլոր առաջարկները, գնային տվյալները, կցված փաստաթղթերը և այլ նյութերը մինչև առաջարկների ներկայացման վերջնաժամկետը հասանելի չեն որևէ մեկին։</p>
      
      <p>13.2. Առաջարկների ներկայացման վերջնաժամկետի լրանալուց և մրցույթի բացումից հետո մրցույթի շրջանակում ներկայացված տվյալները հասանելի են դառնում միայն տվյալ մրցույթի կողմերին՝ կազմակերպչին և մրցույթին մասնակցած համապատասխան օգտատերերին՝ սույն կանոնակարգով և մրցույթի պայմաններով սահմանված կարգով։</p>
      
      <p>13.3. iTender համակարգի օպերատորը մրցույթի ընթացքում չի բացահայտում, չի փոխանցում և չի հրապարակում առաջարկների, գների կամ կցված նյութերի բովանդակությունը մինչև մրցույթի բացումը։</p>
      
      <p>13.4. Մրցույթի կամ հարցման ավարտից հետո մրցույթի շրջանակում ներկայացված տվյալները կարող են պահպանվել iTender համակարգում և օգտագործվել օպերատորի կողմից բացառապես վիճակագրական, վերլուծական և համակարգի զարգացման նպատակներով, այդ թվում՝ շուկայի ընդհանուր վերլուծության, միջին գների հաշվարկի և մրցութային ակտիվության գնահատման համար։</p>
      
      <p>13.5. Սույն կետով նախատեսված նպատակներով տվյալների օգտագործումը իրականացվում է անանուն կամ, այնպես, որ չբացահայտվեն կոնկրետ մասնակցի առևտրային գաղտնիք հանդիսացող տվյալները, եթե այլ բան նախատեսված չէ օրենքով կամ կողմերի միջև կնքված պայմանագրով։</p>
      
      <p>13.6. Օգտատերերը պարտավորվում են մրցույթի շրջանակում ստացված տվյալները օգտագործել բացառապես մրցույթի և պայմանագրի կատարման նպատակով և չհրապարակել կամ չփոխանցել դրանք երրորդ անձանց՝ առանց տվյալների օրինական տիրոջ համաձայնության։</p>
      
      <p>13.7. Սույն բաժնի դրույթների խախտումը կարող է դիտարկվել որպես սույն կանոնակարգի խախտում և առաջացնել 6-րդ բաժնով նախատեսված պատասխանատվության միջոցների կիրառումը։</p>

      <p>13.8. <strong>Աճուրդի ընթացքում տվյալների գաղտնիությունը</strong></p>

      <p>Բաց աճուրդի ընթացքում համակարգը չի բացահայտում մասնակիցների անվանումները, մասնակիցների քանակը, նրանց ներկայացրած առանձին գները և դիրքերը։<br>
      Մասնակիցներին հասանելի է միայն ընթացիկ նվազագույն գինը և իրենց սեփական առաջարկի վերաբերյալ տեղեկատվությունը։<br>
      Աճուրդի ավարտից և արդյունքների ամփոփումից հետո տվյալների հասանելիությունը կարգավորվում է սույն կանոնակարգի, մրցույթի պայմանների և համակարգում կիրառվող հասանելիության կանոններով։</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Regulations',
  mounted() {
    // You can add any initialization logic here
    console.log('Regulations component mounted');
  }
}
</script>

<style scoped>
.regulations-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.regulations-content {
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  color: #2c3e50;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #3498db;
}

h2 {
  color: #2c3e50;
  font-size: 22px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

h3 {
  color: #34495e;
  font-size: 18px;
  font-weight: bold;
  margin-top: 25px;
  margin-bottom: 15px;
}

p {
  margin-bottom: 15px;
  font-size: 14px;
  text-align: justify;
}

strong {
  font-weight: bold;
  color: #2c3e50;
}

ul {
  margin: 15px 0;
  padding-left: 30px;
}

ul li {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.6;
}

/* Responsive design */
@media (max-width: 768px) {
  .regulations-content {
    padding: 20px;
  }
  
  h1 {
    font-size: 24px;
  }
  
  h2 {
    font-size: 20px;
  }
  
  h3 {
    font-size: 16px;
  }
  
  p, ul li {
    font-size: 13px;
  }
}

/* Print styles */
@media print {
  .regulations-container {
    max-width: 100%;
    padding: 0;
  }
  
  .regulations-content {
    box-shadow: none;
    padding: 20px;
  }
}
</style>
